<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex"/>
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <p class="saas-title" style="margin-bottom:0.1rem;">解决方案</p>
    <product-content
      :productContentArr = product
    />
    <div class="saas" v-for="(item, index) in productArr" :key="index" :style="item.boxStyle">
      <p class="saas-title">{{item.label}}</p>
      <p class="saas-content" :style="item.contentStyle">{{item.content}}</p>
      <img :src="item.img" alt="" :style="item.imgStyle">
    </div>
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/saas/1.png'
import i2 from '../assets/images/saas/2.png'
import i3 from '../assets/images/saas/3.png'
import i4 from '../assets/images/saas/4.png'
import i5 from '../assets/images/saas/5.png'
import i6 from '../assets/images/saas/6.png'
import i7 from '../assets/images/saas/7.png'
import i8 from '../assets/images/saas/8.png'
export default {
  data () {
    return {
      product: [
        {img: i1, boxStyle: 'padding-left: 1rem;', content: '可针对行业进行功能定制，目前产品已适配餐饮、零售、珠宝、游乐等行业场景', label: '行业定制', type: 'left', style: 'width: 1.77rem;padding-left: 0.78rem;'},
        {img: i2, boxStyle: 'padding-left: 0.5rem;', content: '整套系统涵盖了门店经营、企业管理的方方面面，主要功能版块有：收银前端、订单管理、会员系统、报表中心、ERP、BI系统、线上商城、集团管控、聚合支付、移动办公、工作流引擎等', label: '功能全面', type: 'right', style: 'width: 1.77rem;padding-right:0.38rem;'},
        {img: i3, boxStyle: 'padding-left: 1rem;', content: '系统整体云端部署，区别于传统的本地系统，可完美解决连锁经营场景多门店数据互联互通，集团数据汇总分析', label: '数据同步', type: 'left', style: 'width: 1.77rem;padding-left: 0.78rem;'},
        {img: i4, boxStyle: 'padding-left: 0.5rem;', content: '基于前海智绘强大的研发和服务团队，整套SaaS系统将持续进行功能迭代与优化，也支持客户需求进行定制，且版本统一更新，真正意义上实现统一升级，无线迭代', label: '无限迭代', type: 'right', style: 'width: 1.77rem;padding-right:0.38rem;'}
      ],
      bannerObj: {
        img: i5,
        title: 'SaaS系统',
        content: '聚焦线下实体门店智能化改造与系统升级，提升门店数字化运营水平',
        button: '业务咨询'
      },
      productArr: [
        {labelStyle: '', imgStyle: 'width: 3.32rem;', contentStyle: 'width: 4.1rem;margin: 0 auto 0.57rem;', boxStyle: 'background:rgba(247,248,248,1);;', label: '场地管理系统（智控系统）', content: '聚焦新零售产业，全面覆盖企业日常经营管理各业务场景，提供标准应用产品在满足功能需求的前提下，使原本散落在企业各个部门，各个场地的价值数据（会员，订单营销，采购，库存，兑换，财务，设备等）全部互联互通', img: i6},
        {labelStyle: '', imgStyle: 'width: 2.8rem;padding-bottom: 0.5rem;', contentStyle: 'width: 4.1rem;margin: 0 auto 0.57rem;', boxStyle: 'background:rgba(255,255,255,1);', label: '会员管理系统（智联系统）', content: '致力于为零售行业连锁品牌提供智能客户运营服务基于营销技术+人工智能、以数据驱动为核心，帮助品牌精准触达场外客户，提升场内客户粘性', img: i7},
        {labelStyle: '', imgStyle: 'width: 4.05rem', contentStyle: 'width: 4.1rem;margin: 0 auto 0.57rem;', boxStyle: 'background:rgba(247,248,248,1);', label: 'C端应用系统（智游系统）', content: '针对零售行业定制开发C端应用系统，支持APP，微信公众号和小程序，帮助场地建立属于自己的蓄客渠道，支持线上购买、兑换，及相关会员操作，支持第三方平台（美团、口碑等）打通，在线发券，领券，参与活动，所有数据均同步至云平台', img: i8}
      ],
      brandStyle: 'background:rbga(255,255,255,1);',
      topIndex: 1,
      childrenIndex: 0,
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    backTop,
    dialogBusiness,
    footerA
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.saas-title{
  font-size:34px;
  font-family:PingFang SC;
  font-weight:bold;
  color:rgba(51,51,51,1);
  padding: 110px 0 30px;
}
.saas-content{
  font-size:20px;
  font-family:PingFang SC;
  font-weight:500;
  line-height:35px;
  color:rgba(102,102,102,1);
  margin-bottom: 30px;
}
.saas{
  background:rgba(247,248,248,1);
  padding-bottom: 30px;
}
.img-style{
  width: 775px;
  height: 324px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/saas.vue